import "./AppointmentDetailsScreen.scss";
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import CardComponent from "../../../shared/components/card/CardComponent";
import {IAPIResponseType} from "../../../shared/models/api.model";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import React, {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../shared/services";
import {ImageConfig, Misc} from "../../../constants";
import BackComponent from "../../../shared/components/back/BackComponent";
import ModalComponent from "../../../shared/components/modal/ModalComponent";
import ClientAndProviderDetailsCardComponent
    from "../../../shared/components/client-and-provider-details-card/ClientAndProviderDetailsCardComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import LoaderComponent from "../../../shared/components/loader/LoaderComponent";
import StatusCardComponent from "../../../shared/components/status-card/StatusCardComponent";
import IconButtonComponent from "../../../shared/components/icon-button/IconButtonComponent";
import SelectDropdownComponent from "../../../shared/components/form-controls/select-dropdown/SelectDropdownComponent";
import RadioButtonComponent from "../../../shared/components/form-controls/radio-button/radioButton";
import ServiceDetailsCardComponent
    from "../../../shared/components/service-details-card-component/ServiceDetailsCardComponent";
import CategoryServiceDetailsComponent
    from "../../book-appointment/facility-carousel/category-service-details-modal/CategoryServiceDetailsComponent";
import RescheduleAppointmentComponent from "./reshedule-appointment/RescheduleAppointmentComponent";
import ChipComponent from "../../../shared/components/chip/ChipComponent";
import moment from "moment-timezone";
import PaymentDetailsComponent from "../../payment-details/PaymentDetailsComponent";
import SecureCheckoutComponent from "../../transaction/secure-checkout/SecureCheckoutComponent";
import AppointmentTaskComponent from "./appointment-task/AppointmentTaskComponent";

interface AppointmentDetailsScreenProps {

}

const AppointmentDetailsScreen = (props: AppointmentDetailsScreenProps) => {

    const {appointmentId} = useParams();
    const [isAppointmentDetailsBeingLoaded, setIsAppointmentDetailsBeingLoaded] = useState<boolean>(false);
    const [isAppointmentDetailsBeingLoading, setIsAppointmentDetailsBeingLoading] = useState<boolean>(false);
    const [isAppointmentDetailsBeingLoadingFailed, setIsAppointmentDetailsBeingLoadingFailed] = useState<boolean>(false);
    const [appointmentDetails, setAppointmentDetails] = useState<any>(undefined);
    const [isReschedulingAppointmentModalOpen, setIsReschedulingAppointmentModalOpen] = useState<boolean>(false);
    const [isReschedulingConfirmationModalOpen, setIsReschedulingConfirmationModalOpen] = useState<boolean>(false);
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const [isPaymentModalOpen, setIsPaymentModalOpen] = useState<boolean>(false);
    const [payType, setPayType] = useState<'checkout' | 'payment_method'>('checkout');
    const [paymentMode, setPaymentMode] = useState<string>('cash');
    const [isPaymentProcessing, setIsPaymentProcessing] = useState<boolean>(false);
    const [openPaymentSuccessModal, setOpenPaymentSuccessModal] = useState<boolean>(false);
    const {paymentModes} = useSelector((state: IRootReducerState) => state.staticData);
    const [availableCouponsList, setAvailableCouponsList] = useState<any[]>([]);
    const [selectedCoupon, setSelectedCoupon] = useState<any>(undefined);
    const [discountAmount, setDiscountAmount] = useState<number>(0);
    const [payableAmount, setPayableAmount] = useState<number>(0);
    const [isCategoryServiceModalOpen, setIsCategoryServiceModalOpen] = useState(false);
    const [searchParams] = useSearchParams();
    const [isSecureCheckOutModalOpen, setIsSecureCheckOutModalOpen] = useState(false);

    const fetchAppointmentDetails = useCallback(() => {
        if (appointmentId) {
            setIsAppointmentDetailsBeingLoading(true);
            let appointmentDetails: any = undefined;
            const payload = {}
            CommonService._appointment.GetUpAppointmentDetails(appointmentId, payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.data) {
                        appointmentDetails = response.data;
                    }
                    setAppointmentDetails(appointmentDetails);
                    setIsAppointmentDetailsBeingLoading(false);
                    setIsAppointmentDetailsBeingLoaded(true);
                    setIsAppointmentDetailsBeingLoadingFailed(false);
                }).catch((error: any) => {
                setIsAppointmentDetailsBeingLoading(false);
                setIsAppointmentDetailsBeingLoaded(false);
                setIsAppointmentDetailsBeingLoadingFailed(true);
                setAppointmentDetails(appointmentDetails);
            })
        }
    }, [appointmentId]);

    const getAvailableCouponsList = useCallback(() => {
        const payload = {
            service_id: appointmentDetails?.service_details?._id,
            amount: appointmentDetails?.payment_details?.total,
        }
        CommonService._appointment.getAvailableCouponsList(payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    setAvailableCouponsList(response.data);
                }
            })
            .catch((error: any) => {
                CommonService._alert.showToast(error.error || error.errors || "Failed to fetch", "error");
            });
    }, [appointmentDetails]);

    useEffect(() => {
        if (appointmentId) {
            fetchAppointmentDetails();
        }
    }, [appointmentId, fetchAppointmentDetails]);

    useEffect(() => {
        if (appointmentDetails?.service_details?._id && appointmentDetails?.payment_details?.total) {
            getAvailableCouponsList();
        }
    }, [appointmentDetails, getAvailableCouponsList]);

    const navigate = useNavigate();

    const navigateToAppointmentList = useCallback(() => {
        const referrer: any = searchParams.get("referrer");
        if (referrer) {
            navigate(referrer);
        } else {
            navigate(CommonService._routeConfig.AppointmentList());
        }


    }, [navigate, searchParams]);

    const handleRescheduleAppointment = useCallback(() => {
        const now: any = new Date();
        const appointmentDate: any = new Date(appointmentDetails?.appointmentDateTime);
        const diffInMs = appointmentDate - now;
        const diffInHours = diffInMs / (1000 * 60 * 60);

        if (diffInHours > 24) {
            setIsReschedulingConfirmationModalOpen(true)
        } else if (diffInHours > 0 && diffInHours <= 24) {
            CommonService.onConfirm({
                image: ImageConfig.BlueConfirmationLottie,
                showLottie: true,
                hideNoOption: true,
                confirmationSubTitle: <div>To reschedule your appointment, please contact <br/>
                    us
                    at <b
                        className={'phone-number'}>{CommonService.formatPhoneNumber(appointmentDetails?.facility_details?.primary_contact_info?.phone)}</b>
                    <br/><br/>Note: Appointments can be rescheduled up to<br/>24 hours prior to the appointment.
                </div>,
                yes: {
                    text: 'Close',
                    variant: 'contained',
                }
            })
        } else {
            CommonService.onConfirm({
                image: ImageConfig.BlueConfirmationLottie,
                showLottie: true,
                hideNoOption: true,
                confirmationSubTitle: <div>To reschedule your appointment, please contact <br/>
                    us
                    at <b
                        className={'phone-number'}>{CommonService.formatPhoneNumber(appointmentDetails?.facility_details?.primary_contact_info?.phone)}</b>
                    <br/><br/>Note: Appointment time has passed.
                </div>,
                yes: {
                    text: 'Close',
                    variant: 'contained',
                }
            })
        }
        // setIsReschedulingConfirmationModalOpen(true);
    }, [appointmentDetails]);

    const handleRescheduleAppointmentModalClose = useCallback(() => {
        setIsReschedulingAppointmentModalOpen(false);
    }, []);

    const handlePaymentModalClose = useCallback(() => {
        setIsPaymentModalOpen(false);
    }, []);

    const makePayment = useCallback(() => {
        setIsPaymentProcessing(true);
        const payload = {
            payment_mode: paymentMode,
            total: appointmentDetails?.payment_details?.total,
            coupon_id: selectedCoupon?._id,
        }
        CommonService._appointment.makePayment(appointmentDetails._id, payload)
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                fetchAppointmentDetails();
                setIsPaymentProcessing(false);
                setIsPaymentModalOpen(false);
                setOpenPaymentSuccessModal(true);
            })
            .catch((error: any) => {
                setIsPaymentProcessing(false);
            });
    }, [paymentMode, appointmentDetails, selectedCoupon, fetchAppointmentDetails]);

    const onCouponSelect = useCallback((value: any) => {
        setSelectedCoupon(value);
        if (value.discount_type === 'amount') {
            setDiscountAmount(value.amount)
            const totalPayableAmount = appointmentDetails?.payment_details?.total - value.amount
            setPayableAmount(totalPayableAmount);
        } else {
            let totalPayableAmount;
            const finalDiscountAmount = CommonService.calculateFinalAmountFromDiscountPercentage(value.percentage, appointmentDetails.payment_details.total)
            if (finalDiscountAmount > value.max_discount_amount) {
                totalPayableAmount = appointmentDetails?.payment_details?.total - value.max_discount_amount
            } else {
                totalPayableAmount = appointmentDetails?.payment_details?.total - finalDiscountAmount
            }
            setPayableAmount(totalPayableAmount);
        }
    }, [appointmentDetails]);


    const handleCategoryServiceModalClose = useCallback(() => {
        setIsCategoryServiceModalOpen(false)
    }, []);

    const handleCheckTotal = useCallback(() => {
            if (appointmentDetails?.payment_status === 'unpaid') {
                return appointmentDetails?.payment_details?.total - appointmentDetails?.payment_details?.discount;
            } else if (appointmentDetails?.payment_status === 'paid') {
                return appointmentDetails?.payment_details?.payable_amount;
            }
        }, [appointmentDetails]
    );

    const handleCancelModal = useCallback(() => {
        CommonService.onConfirm({
            image: ImageConfig.BlueConfirmationLottie,
            showLottie: true,
            hideNoOption: true,
            confirmationSubTitle: <>To cancel your appointment, please contact <br/>
                us
                at <b
                    className={'phone-number'}>{CommonService.formatPhoneNumber(appointmentDetails?.facility_details?.primary_contact_info?.phone)}</b>
                <br/><br/>Note: Cancellations made within 24 hours of an<br/>appointment may incur a cancellation
                fee.</>,
            yes: {
                text: 'Cancel',
                variant: 'contained',
            }
        })
    }, [appointmentDetails]);

    return (
        <div className={'appointment-details-screen'}>
            <div className={'appointment-details-header'}>
                <BackComponent onClick={navigateToAppointmentList}/>
                {(appointmentDetails?.status === 'scheduled' || appointmentDetails?.status === 'upcoming') &&
                    <div className={'d-flex'}>
                        <ButtonComponent className={'mrg-right-10'}
                                         onClick={handleCancelModal}
                                         color={'error'} size={'small'} variant={'outlined'}>
                            Cancel Appointment
                        </ButtonComponent>
                        <ButtonComponent color={'accent'} variant={'outlined'} size={'small'}
                                         onClick={handleRescheduleAppointment}>
                            Reschedule Appointment
                        </ButtonComponent>
                    </div>}
            </div>
            {
                isAppointmentDetailsBeingLoading && <div>
                    <LoaderComponent/>
                </div>
            }
            {
                isAppointmentDetailsBeingLoadingFailed &&
                <StatusCardComponent title={"Failed to fetch medical Details"}/>
            }
            {isAppointmentDetailsBeingLoaded && <>
                <div className={"ts-row"}>
                    <div className={'details-wrapper ts-col-lg-8 ts-col-md-12 ts-col-sm-12 '}>
                        <CardComponent className={`${appointmentDetails?.payment_status==='paid'?'paid-card':'unpaid-card' }`}>
                            <div className={'header-status-wrapper'}>
                                <div className={'heading-status-wrapper__heading'}>
                                    Appointment Details
                                </div>

                                <div>
                                    {
                                        (appointmentDetails?.waive_cancellation_fee || appointmentDetails?.waive_no_show_fee) &&
                                        <ChipComponent label={'Fee:_Waived'} className={'upcoming mrg-right-15'}/>
                                    }
                                    <ChipComponent
                                        label={appointmentDetails?.status}
                                        className={appointmentDetails?.status}/>
                                </div>
                            </div>
                            <div className={'appointment-details-wrapper'}>

                                <div className={'transaction-details-upper-item'}>
                                    <div className={'container'}>
                                        <div className={'icon-wrapper'}>
                                            <ImageConfig.AppointmentCalendarIcon/>
                                        </div>
                                        <div className={'details-wrapper'}>
                                            Appointment Date
                                            <div
                                                className={'mrg-top-5'}>
                                                <b>{CommonService.transformTimeStamp(appointmentDetails?.appointment_date, false)}</b>
                                            </div>

                                        </div>
                                    </div>

                                    <div className={'container  justify-content-center'}>
                                        <div className={'icon-wrapper'}>
                                            <ImageConfig.ClockIcon height={30} width={30}/>
                                        </div>
                                        <div className={'details-wrapper'}>
                                            <div>Appointment Time</div>
                                            <div
                                                className={'mrg-top-5'}>
                                                <b>{CommonService.getHoursAndMinutesFromMinutes(appointmentDetails?.start_time)}</b>
                                            </div>

                                        </div>
                                    </div>
                                    <div className={'container justify-content-center last-container'}>
                                        <div className={'icon-wrapper'}>
                                            <ImageConfig.PersonIcon height={30} width={30}/>
                                        </div>
                                        <div className={'details-wrapper'}>
                                            <div>Provider Name</div>
                                            <div
                                                className={'mrg-top-5 provider-name-wrapper'}>
                                                <b>{appointmentDetails?.provider_details?.first_name ? appointmentDetails?.provider_details?.first_name + ' ' + appointmentDetails?.provider_details?.last_name : 'N/A'}</b>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className={'description-wrapper'}>
                                    <div className={'icon-wrapper'}>
                                        <ImageConfig.DocumentIcon height={30} width={30}/>
                                    </div>
                                    <div>
                                        <div className={'description-heading'}>Description</div>
                                        <div className={'description-body'}>
                                            <b> {appointmentDetails?.category_details?.name} - {appointmentDetails?.service_details?.name}</b>

                                        </div>
                                    </div>
                                </div>
                                <div className={'description-wrapper last-container'}>
                                    <div className={'icon-wrapper'}>
                                        <ImageConfig.DocumentClipIcon height={30} width={30}/>
                                    </div>
                                    <div>
                                        <div className={'description-heading'}>Case Name</div>
                                        <div className={'description-body'}>
                                            {
                                                (appointmentDetails?.record_type === 'medical_record' && appointmentDetails?.record_id) && (
                                                    <b>
                                                        {CommonService.getDateFromTimezone(appointmentDetails?.case_details?.created_at, moment.tz.guess(), 'DD-MMM-YYYY')}{' - '}
                                                        {appointmentDetails?.case_details?.injury_details?.map((injury: any, index: number, array: any[]) => (
                                                            <span key={index}>
                                                                            {" "}
                                                                {injury.body_part_name}
                                                                {injury?.body_side ? ` (${injury?.body_side})` : ''}
                                                                {index !== array.length - 1 && " |"}
                                                                            </span>
                                                        ))}
                                                    </b>
                                                )
                                            }
                                            {
                                                appointmentDetails?.record_type === 'performance_record' && appointmentDetails?.record_id &&
                                                <>
                                                    <b> {CommonService.getDateFromTimezone(appointmentDetails?.case_details?.created_at, moment.tz.guess(), 'DD-MMM-YYYY')} - {appointmentDetails?.case_details?.program_focus}</b>

                                                </>
                                            }
                                            {
                                                !appointmentDetails?.record_id &&
                                                <b>{appointmentDetails?.case_name || 'N/A'}</b>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardComponent>
                    </div>
                    <div className={'ts-col-lg-4 ts-col-md-12 ts-col-sm-12'}>

                        <PaymentDetailsComponent
                            enablePay={appointmentDetails?.enable_pay_now}
                            total={appointmentDetails?.payment_details?.total - appointmentDetails?.payment_details?.discount}
                            discount={appointmentDetails?.payment_details?.coupon_discount || 0}
                            paymentStatus={appointmentDetails?.payment_status}
                            paymentMethod={appointmentDetails?.payment_details?.payment_mode && appointmentDetails?.payment_details?.payment_mode}
                            payableAmount={appointmentDetails?.payment_details?.payment_for === 'waived' ? 0 : handleCheckTotal()}
                            isWaived={appointmentDetails?.payment_details?.payment_for === 'waived'}
                            refundAmount={appointmentDetails?.payment_details?.payment_for === 'waived' ? handleCheckTotal() : 0}
                            onPayNowClick={() => setIsSecureCheckOutModalOpen(true)}
                        />
                    </div>
                </div>
                <>
                    <AppointmentTaskComponent
                        appointmentDetails={appointmentDetails}
                        formStatus={appointmentDetails?.form_status}/>
                </>
            </>}
            <ModalComponent isOpen={isSecureCheckOutModalOpen}
                            closeOnBackDropClick={false}
            >
                <SecureCheckoutComponent setIsSecureCheckOutModalOpen={setIsSecureCheckOutModalOpen}
                                         selectedId={appointmentDetails?.payment_details?._id}
                                         location={'appointments'}
                                         appointmentDetails={appointmentDetails}
                                         isComingFromListScreen={true}/>
            </ModalComponent>

            <ModalComponent
                isOpen={isReschedulingAppointmentModalOpen}
                onClose={handleRescheduleAppointmentModalClose}
                size={'xl'}
            >
                <div className="appointment-details_modal-container">
                    {isReschedulingAppointmentModalOpen &&
                        <RescheduleAppointmentComponent fetchAppointmentDetails={fetchAppointmentDetails}
                                                        setIsReschedulingAppointmentModalOpen={setIsReschedulingAppointmentModalOpen}
                                                        setIsCategoryServiceModalOpen={setIsCategoryServiceModalOpen}
                                                        appointmentDetails={appointmentDetails}/>
                    }
                </div>
            </ModalComponent>

            <ModalComponent
                isOpen={isCategoryServiceModalOpen}
                onClose={handleCategoryServiceModalClose}
            >
                <CategoryServiceDetailsComponent handleCategoryServiceModalClose={handleCategoryServiceModalClose}
                                                 selectedServiceDetails={appointmentDetails?.service_details}
                                                 selectedCategoryDetails={appointmentDetails?.category_details}/>
            </ModalComponent>

            <ModalComponent
                isOpen={isReschedulingConfirmationModalOpen}
                onClose={handleRescheduleAppointmentModalClose}
            >
                <div className="reschedule-appointment-component-confirmation-modal">
                    <div className={''}>
                        <div className={'mrg-top-50 mrg-bottom-25'}>
                            <ImageConfig.RescheduleComplementaritiesPopup/>
                        </div>
                        <div className="confirmation-wrapper pdd-left-65 pdd-right-65">
                            <div className={'mrg-bottom-50'}>
                                Are you sure you want to <span className="bold-inner-text">reschedule</span> the <br/>
                                appointment
                                with <span
                                className="bold-inner-text"> {CommonService.capitalizeFirstLetter(appointmentDetails?.provider_details?.first_name)} {CommonService.capitalizeFirstLetter(appointmentDetails?.provider_details?.last_name)} </span> on <span
                                className="bold-inner-text"> {CommonService.transformTimeStamp(appointmentDetails?.appointment_date, false)} </span>?
                            </div>
                            <div className={'d-flex mrg-bottom-40'}>
                                <ButtonComponent
                                    className="mrg-right-10"
                                    variant={"outlined"}
                                    fullWidth={true}
                                    color={"default"}
                                    onClick={() => setIsReschedulingConfirmationModalOpen(false)}>No</ButtonComponent>
                                <ButtonComponent
                                    className="mrg-left-10"
                                    fullWidth={true}
                                    color={"accent"}
                                    onClick={() => {
                                        setIsReschedulingAppointmentModalOpen(true);
                                        setIsReschedulingConfirmationModalOpen(false)
                                    }}
                                >Yes</ButtonComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalComponent>

            <ModalComponent
                isOpen={isPaymentModalOpen}
                onClose={handlePaymentModalClose}
            >
                <div className="appointment-details_modal-container">
                    <div className="appointment-details_modal__left-container">
                        <div className="appointment-details_modal__left-container-header__wrapper">
                            <div className="appointment-details_modal__left-container__title">Appointment Details</div>
                            <div className="appointment-details_modal__left-container__button_section">
                                <div className="appointment-details_modal__left-container__button">
                                    {appointmentDetails?.appointment_type === 'followup_consultation' ? 'Followup Consultant' : 'Int Consult'}
                                </div>
                                &nbsp;&nbsp;
                                <div className="appointment-details_modal__left-container__button">
                                    <span><ImageConfig.TimerIcon/></span>
                                    {appointmentDetails?.duration} min
                                </div>
                            </div>
                        </div>
                        <div>
                            <ServiceDetailsCardComponent serviceDetails={appointmentDetails}/>
                            <ClientAndProviderDetailsCardComponent type={'client'} client={currentUser}/>
                            <ClientAndProviderDetailsCardComponent type={'provider'}
                                                                   provider={appointmentDetails?.provider_details}/>
                            <ClientAndProviderDetailsCardComponent type={'time'}
                                                                   appointmentDate={appointmentDetails?.appointment_date}
                                                                   appointmentTime={appointmentDetails?.appointment_date}/>

                        </div>
                    </div>
                    <div className="appointment-details_modal__right-container">
                        {payType === 'checkout' &&
                            <div className="modal-close" onClick={() => handlePaymentModalClose()}>
                                <ImageConfig.CloseIcon/>
                            </div>
                        }
                        {
                            payType === 'payment_method' && <>
                                <div className="back_navigation">
                                    <IconButtonComponent className="navigation_icon"
                                                         onClick={() => setPayType('checkout')}
                                    >
                                        <ImageConfig.LeftArrow/>
                                    </IconButtonComponent>
                                    <span className="back_navigation_text"> Previous </span>
                                </div>
                            </>
                        }
                        <div className="appointment-details_modal__right-container_title">
                            {payType === 'checkout' ? 'Secure Checkout' : 'Select Payment Method'}
                        </div>
                        {payType === 'checkout' &&
                            <div className="checkout-payment-details__info__wrapper">
                                <div className={'checkout-payment-details-header__info grand-total'}>
                                    <div className={'checkout-payment-details-header__info__label'}>
                                        Total Amount (Incl. Tax)
                                    </div>
                                    <div className={'checkout-payment-details-header__info__value'}>
                                        ${CommonService.convertToDecimals(appointmentDetails?.payment_details?.total) || 'N/A'}
                                    </div>
                                </div>
                                <div className={'checkout-payment-details__promotion_code_wrapper'}>
                                    <div className="promotion_code_text_msg">Add a gift card or promotion code or
                                        voucher
                                    </div>
                                    <div className="promotion_code_input_wrapper">
                                        <SelectDropdownComponent
                                            size={"small"}
                                            placeholder={"Select Code"}
                                            options={availableCouponsList}
                                            displayWith={(option: any) => option?.title}
                                            valueExtractor={(option: any) => option}
                                            onUpdate={(value: any) => {
                                                onCouponSelect(value);
                                            }}
                                        />
                                    </div>

                                    <div className={'checkout-payment-details__sub-section-breakup'}>
                                        <div className="checkout-payment-details__title">Checkout Summary</div>
                                        <div className={'checkout-payment-details__info gross-total'}>
                                            <div className={'checkout-payment-details__info__label'}>
                                                Amount
                                            </div>
                                            <div className={'checkout-payment-details__info__value'}>
                                                ${CommonService.convertToDecimals(appointmentDetails?.payment_details?.total) || 'N/A'}
                                            </div>
                                        </div>
                                        <div className={'checkout-payment-details__info discount'}>
                                            <div className={'checkout-payment-details__info__label'}>
                                                Discount
                                            </div>
                                            <div className={'checkout-payment-details__info__value'}>
                                                {selectedCoupon ? `- $${CommonService.convertToDecimals(discountAmount)}` : `$${CommonService.convertToDecimals(appointmentDetails?.payment_details?.discount)}` || 'N/A'}
                                            </div>
                                        </div>
                                        <div className={'checkout-payment-details__info net-amount'}>
                                            <div className={'payment-details__info__label'}>
                                                Total Amount (Inc. tax)
                                            </div>
                                            <div className={'payment-details__info__value'}>
                                                ${selectedCoupon ? payableAmount : CommonService.convertToDecimals(appointmentDetails?.payment_details?.payable_amount) || 'N/A'}
                                            </div>
                                        </div>
                                    </div>

                                    {(payableAmount || appointmentDetails?.payment_details?.payable_amount) &&
                                        <div className={'checkout-payment-details__button'}>
                                            <ButtonComponent
                                                fullWidth={true}
                                                onClick={() => {
                                                    setPayType('payment_method')
                                                }}>
                                                Checkout
                                            </ButtonComponent>
                                        </div>}

                                </div>
                            </div>
                        }
                        {
                            payType === 'payment_method' && <>
                                <div className="final-payment-details__info__wrapper">
                                    <div className={'final-payment-details-header__info grand-total'}>
                                        <div className={'final-payment-details-header__info__label'}>
                                            Total Amount (Incl. Tax)
                                        </div>
                                        <div className={'final-payment-details-header__info__value'}>
                                            ${selectedCoupon ? payableAmount : CommonService.convertToDecimals(appointmentDetails?.payment_details?.payable_amount) || 'N/A'}
                                        </div>
                                    </div>
                                    <div className={'mrg-top-20 payment-methods-wrapper'}>
                                        {paymentModes && paymentModes.map((item: any) => {
                                            return (
                                                <CardComponent>
                                                    <div className={'final-payment-details__payment-method__radio'}>
                                                        <RadioButtonComponent
                                                            label={item.title}
                                                            name={'payment-method'}
                                                            checked={paymentMode === item.code}
                                                            onChange={() => setPaymentMode(item.code)}
                                                        />
                                                    </div>
                                                </CardComponent>
                                            )
                                        })}
                                    </div>

                                    <div>
                                        <ButtonComponent fullWidth={true}
                                                         isLoading={isPaymentProcessing}
                                                         onClick={() => {
                                                             makePayment()
                                                         }}>
                                            Submit
                                        </ButtonComponent>
                                    </div>

                                </div>
                            </>
                        }
                    </div>
                </div>
            </ModalComponent>


            <ModalComponent isOpen={openPaymentSuccessModal}
                            size={'xs'}
                            className=""
                            onClose={() => setOpenPaymentSuccessModal(false)}>
                <div className="payment-success-modal__content">
                    <div className={'success-popup-component'}>
                        <div className={'success-popup-image'}>
                            <img src={ImageConfig.Tick} alt={'success-popup-tick'}/>
                        </div>
                        <div className="success-popup-meta">
                            <div className={'success-popup-title'}>
                                ${selectedCoupon ? payableAmount : CommonService.convertToDecimals(appointmentDetails?.payment_details?.payable_amount) || 'N/A'}
                            </div>
                            <div className={'success-popup-title'}>
                                Payment Success!
                            </div>

                            <div className={'success-popup-cta'}>
                                <ButtonComponent className={'width-50'}
                                                 onClick={() => setOpenPaymentSuccessModal(false)}
                                >
                                    Close
                                </ButtonComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalComponent>


        </div>
    );

};

export default AppointmentDetailsScreen;
